import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=31676923&scoped=true&"
import script from "./SummaryCard.vue?vue&type=script&lang=ts&"
export * from "./SummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&id=31676923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31676923",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
